import {
    select as D3select,
    dispatch as D3dispatch,
} from 'd3';

const D3Button = function () {
    const dispatch = D3dispatch('press', 'release');
    const padding = 7;
    let bbox;
    let disabled = () => false;
    let round = false;

    function my (selection) {
        if (!selection) return;
        selection.each(function (data, i) {
            const isDisabled = disabled(data);
            const g = D3select(this)
                .attr('id', 'd3-button' + i)
                .attr('transform', 'translate(' + data.x + ',' + data.y + ')')
                .classed('zbtn', true)
                .style('shape-rendering', 'crispEdges')
                .style('cursor', isDisabled ? '' : 'pointer');

            const rect = g.selectAll('rect').data([data], d => d.key);
            const rmerge = rect.enter()
                .insert('rect', 'text')
                .merge(rect);

            const tjoin = g.selectAll('path').data([data], d => d.key);
            tjoin.enter()
                .append('path')
                .merge(tjoin)
                .attr('d', d => d.path)
                .attr('transform', function (d) {
                    // shrink and center the icon
                    const b = D3select(this).node().getBBox();
                    const size = Math.max(b.width, b.height);
                    return `scale(0.8) translate(${(size - b.width) / 2},${(size - b.height) / 2})`;
                })
                .style('pointer-events', 'none')
                .classed('disabled', isDisabled)
                .each(function (d) { bbox = D3select(this).node().getBBox() });
            tjoin.exit().remove();

            rmerge.attr('x', bbox.x - padding)
                .attr('y', bbox.y - padding)
                .attr('rx', round ? 4 : 0)
                .style('width', '24px')
                .style('height', '24px')
                .on('click', function (event, d, i) {
                    // D3event.stopPropagation();
                    event.stopPropagation();
                    !isDisabled && press.call(this, d, i);
                });
            rect.exit().remove();
        });
    }

    function press (d, i) {
        dispatch.call('press', my, this, d, i);
        D3select(this).classed('pressed', true);
        const shadow = D3select(this.parentNode).select('filter');
        if (!shadow.node()) return;
        shadow.select('feOffset').attr('dx', 0).attr('dy', 0);
        shadow.select('feGaussianBlur').attr('stdDeviation', 0);
    }

    my.on = function () {
        const value = dispatch.on.apply(dispatch, arguments);
        return value === dispatch ? my : value;
    };

    my.disabled = function (v) {
        if (!arguments.length) return disabled;
        disabled = v;
        return my;
    };

    my.round = function (v) {
        if (!arguments.length) return round;
        round = v;
        return my;
    };

    return my;
};

export default D3Button;
